<template>
  <div>
    <v-row v-if="activeType === 'voucher'" class="mb-2">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.quantity_in_period"
          :label="$t('how_many_vouchers_in_period')"
          type="number"
          outlined
          dense
          :hint="$t('number_of_vouchers_available_in_custom_period')"
          persistent-hint
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'order'" class="mb-2">
      <v-col v-if="config.settings.limit_by_quantity" cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_orders"
          :label="$t('how_many_orders_in_period')"
          type="number"
          outlined
          dense
          :hint="$t('max_orders_hint')"
          persistent-hint
          :readonly="readonly"
        />
      </v-col>
      <v-col v-if="config.settings.limit_by_value" cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_order_value"
          :label="$t('max_order_value')"
          type="number"
          :suffix="restaurantCurrency"
          outlined
          dense
          :hint="$t('max_order_value_hint')"
          persistent-hint
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'credit'" class="mb-2">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_amount"
          :label="$t('credit_amount_in_period')"
          type="number"
          :suffix="restaurantCurrency"
          outlined
          dense
          :hint="$t('credit_amount_available_in_custom_period')"
          persistent-hint
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'money'" class="mb-2">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.limit_amount"
          :label="$t('money_limit_amount_in_period')"
          type="number"
          :suffix="restaurantCurrency"
          outlined
          dense
          :hint="$t('money_limit_amount_in_custom_period_hint')"
          persistent-hint
          :readonly="readonly"
        />
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col cols="12" sm="6">
        <date-picker
          :value="timingSettings.start_date"
          @input="timingSettings.start_date = $event"
          :label="$t('from')"
          single-date
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <date-picker
          :value="timingSettings.end_date"
          @input="timingSettings.end_date = $event"
          :label="$t('to')"
          single-date
          :readonly="readonly"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "CustomPeriodLimitFields",
  props: {
    config: {
      type: Object,
      required: true,
    },
    activeType: {
      type: String,
      required: true,
    },
    timingSettings: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
